/*
 * Forge Maestro
 * (c) Honeywell
 */

import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { IconBase } from '../IconBase.js';
import { IconName } from '../IconName.enum.js';

const EditIcon = forwardRef((props, ref) => {
    const { className = '', title, strokeWidth = 1.5 } = props;
    return (jsx(IconBase, Object.assign({ ref: ref, className: className, title: title, name: IconName.Edit }, { children: jsx("path", { strokeWidth: strokeWidth, strokeLinecap: "round", strokeLinejoin: "round", d: "M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7M18.5 2.5a2.121 2.121 0 1 1 3 3L12 15l-4 1 1-4 9.5-9.5Z" }) })));
});

export { EditIcon };
//# sourceMappingURL=EditIcon.js.map
